import styled from 'styled-components';
import colors from 'styles/colors';
import { BrandCode } from 'types';

export const Container = styled.div`
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
            font-family: ${theme.typography.fontFamilySemiBold};     
            font-size: 17px;
	        line-height: 20px;       
        `,
			[BrandCode.RoyalCaribbean]: `
            font-family: ${theme.typography.fontFamilySemiBold};
            font-size: 18px;
            line-height: normal;            
        `,
		})[theme.brandCode]}
`;

export const Title = styled.h3`
	margin-bottom: 10px;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `                        
            color: ${colors.celebrity.blue};
            line-height: normal;
            font-weight: 600;
        `,
			[BrandCode.RoyalCaribbean]: `                        
            color: ${colors.secondary.deepCoveLight};
            font-weight: 600;
	        line-height: normal;
          
        `,
		})[theme.brandCode]}
`;

export const Description = styled.p`
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `                        
            color: ${colors.celebrity.grey};
            line-height: 18.75px;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            font-family: ${theme.typography.fontFamily};
            margin-bottom: 15px;
        `,
			[BrandCode.RoyalCaribbean]: `                        
            color: ${colors.functional.darkGrey};
            font-family: ${theme.typography.fontFamily};
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 15px;
        `,
		})[theme.brandCode]}
`;

export const Suggest = styled.a`
	cursor: pointer;
	font-style: italic;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `                        
            color: ${colors.celebrity.blue};
            line-height: 125%;
            font-size: 15px;
            font-weight: 600;
            font-family: ${theme.typography.fontFamily};              
        `,
			[BrandCode.RoyalCaribbean]: `                        
            color: ${colors.primary.ocean};
	        line-height: 20px;
            font-size: 16px;
            font-weight: 600;
            font-family: ${theme.typography.fontFamilySemiBold};
            text-decoration: underline;                              
        `,
		})[theme.brandCode]}
`;
